import { render } from "./Soso.vue?vue&type=template&id=252fc14c&scoped=true"
import script from "./Soso.vue?vue&type=script&lang=js"
export * from "./Soso.vue?vue&type=script&lang=js"

import "./Soso.vue?vue&type=style&index=0&id=252fc14c&lang=css"
import "./Soso.vue?vue&type=style&index=1&id=252fc14c&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252fc14c"]])

export default __exports__